var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.527344 30C0.552488 27.8578 0.998329 25.7414 1.83952 23.7712C2.75804 21.9319 6.59895 20.6569 11.4202 18.8719C12.723 18.3881 12.5093 14.9831 11.932 14.3475C11.0122 13.3513 10.3136 12.1716 9.88196 10.8861C9.45033 9.60065 9.2955 8.23835 9.42762 6.88875C9.34502 6.02977 9.44004 5.16298 9.70678 4.34232C9.97352 3.52165 10.4063 2.76468 10.9781 2.11851C11.5499 1.47234 12.2485 0.95079 13.0305 0.586326C13.8125 0.221861 14.6612 0.0222792 15.5236 0C16.3867 0.0212676 17.2361 0.220106 18.019 0.584125C18.8019 0.948144 19.5015 1.46954 20.0741 2.11583C20.6467 2.76211 21.0801 3.51943 21.3473 4.34059C21.6145 5.16175 21.7097 6.02916 21.6271 6.88875C21.7592 8.23835 21.6044 9.60065 21.1727 10.8861C20.7411 12.1716 20.0425 13.3513 19.1227 14.3475C18.5453 14.9831 18.3316 18.3881 19.6344 18.8719C24.4557 20.6569 28.2967 21.9319 29.2152 23.7712C30.0564 25.7414 30.5022 27.8578 30.5273 30H0.527344Z",
    fill: "#F7F1EC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.9f7d88246041c95c543a757fb61a728a.svg";
export { ForwardRef as ReactComponent };